import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { Shared, UserService } from "@rubii/frontend-common";

@Injectable()
export class ConfigService {
    public root: string;

    public version: string;

    public brand: string = "Rubii";

    public keys = {
        captcha: "6Lecy6QUAAAAADM-2fVlwFEobd_hk-8fhU30bu-e",
    };

    public fbAppId = "1303952576292822";

    public inClientId = "86uhfhscqy1b6j";

    public customMetricRoot: string;
    public notificationRoot: string;
    public dashboardRoot = '';
    public openaiRoot = '';
    public agentRoot = '';

    

    constructor(private userService: UserService) {
        this.root = environment.accountRoot;
        this.notificationRoot = environment.notificationRoot;
        this.customMetricRoot = environment.customMetricRoot;
        this.dashboardRoot = environment.dashboardRoot;
        this.openaiRoot = environment.openaiRoot;
        this.agentRoot = environment.agentRoot;
        this.userService.accountHost = environment.accountHost;
        this.userService.backendUrl = this.root;
        this.userService.advertiserHost = environment.advertiserHost;
        this.userService.orderHost = environment.orderHost;
        this.userService.reportHost = environment.reportHost;
        this.userService.trackerHost = environment.trackerHost;
        this.userService.helpHost = environment.helpHost;
        this.userService.reconcileHost = environment.reconcileHost;
        Shared.helpers.LogHelper.init(environment.loglevel);
    }
}
